<template>
  <v-modal
    v-if="true"
    @hide-modal="$emit('hide-modal')"
    :closable="false"
    :body-padding="false"
  >
    <template v-slot:body>
      <div class="sw-main sw-theme-default">
        <ul class="card px-4 pt-3 nav nav-tabs step-anchor mb-3">
          <li
            class="nav-item"
            :class="{active: currentStep === 1}"
          >
            <a
              class="mb-3 nav-link clickable"
              href="#"
              @click.prevent="currentStep = 1"
            >
              <span class="sw-done-icon ion ion-md-checkmark"></span>
              <span class="sw-number">
                <i class="fa fa-door-open"></i>
              </span>
              <div class="text-muted small">
                <span class="d-none d-md-inline-block">{{ $t('word.step').toUpperCase() }}</span>
                1
              </div>
              <span class="d-none d-md-block">{{ $t('word.welcome') }}!</span>
            </a>
          </li>
          <li
            class="nav-item"
            :class="{active: currentStep === 2}"
          >
            <a
              class="mb-3 nav-link clickable"
              href="#"
              @click.prevent="currentStep = 2"
            >
              <span class="sw-done-icon ion ion-md-checkmark"></span>
              <span class="sw-number">
                <i class="fa fa-coins"></i>
              </span>
              <div class="text-muted small">
                <span class="d-none d-md-inline-block">{{ $t('word.step').toUpperCase() }}</span>
                2
              </div>
              <span class="d-none d-md-block">{{ $t('phrase.enable_coin_account') }}</span>
            </a>
          </li>
          <li
            class="nav-item"
            :class="{active: currentStep === 3}"
            @click="goToStepThree()"
          >
            <a
              class="mb-3 nav-link clickable"
              href="#"
              @click.prevent="goToStepThree()"
            >
              <span class="sw-done-icon ion ion-md-checkmark"></span>
              <span class="sw-number">
                <i class="fa fa-star"></i>
              </span>
              <div class="text-muted small">
                <span class="d-none d-md-inline-block">{{ $t('word.step').toUpperCase() }}</span>
                3
              </div>
              <span class="d-none d-md-block">{{ $t('phrase.start_with_reviewing') }}</span>
            </a>
          </li>
        </ul>
        <div class="wizard-content-wrapper pt-3 pr-4 pl-4">
          <transition name="fade-nl">
            <div
              class="row text-center"
              v-if="currentStep === 1"
            >
              <div class="col-md-6" :class="cellClass">
                <img
                  class="w-75 w-md-100 mb-5 mb-md-0"
                  src="@/common/assets/img/logo.png"
                  alt="commercialreview"
                />
              </div>

              <div class="col-md-6" :class="cellClass">
                <h3>
                  {{ $t('word.welcome') }}
                </h3>

                <div class="text-muted">
                  {{ $t('page.onboarding.welcome') }}
                </div>
              </div>
            </div>
          </transition>
          <transition name="fade-nl">
            <div
              class="row wizard-content"
              v-if="currentStep === 2"
            >
              <div class="col-md-7 text-center text-muted mb-3" :class="cellClass">
                <div><i class="fa fa-info text-info"></i></div>
                {{ $t('page.onboarding.coin_account_explanation') }}
              </div>

              <div class="col-md-5">
                <div class="card card-body bg-light">
                  <div class="mb-3">
                    <v-text-input
                      id="onboarding-zip"
                      label="word.zip"
                      help-text="phrase.zip_four_digits"
                      v-model="formData.zip"
                      :errors="errors.zip"
                      :max-length="4"
                    />
                  </div>

                  <div class="mb-3">
                    <v-radio-buttons
                      id="onboarding"
                      label="word.gender"
                      :choices="GENDER_CHOICES"
                      v-model="formData.gender"
                      :errors="errors.gender"
                      :horizontal="true"
                    />
                  </div>

                  <div>
                    <v-date-input
                      id="onboarding-birth-date"
                      label="word.birth_date"
                      :errors="errors.birth_date"
                      v-model="formData.birth_date"
                      :max-date="new Date()"
                      :min-date="new Date(1900, 1, 1)"
                      :required="true"
                    />
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <transition name="fade-nl">
            <div
              :class="cellClass"
              v-if="currentStep === 3"
            >
              <div v-if="dataComplete" class="alert alert-success text-center">
                <div class="text-success">
                  <i class="fa fa-check-double"></i>
                </div>

                {{ $t('page.onboarding.coin_account_success') }}
              </div>
              <div
                v-else
                class="alert alert-danger text-center"
              >
                <div class="text-danger">
                  <i class="fa fa-exclamation"></i>
                </div>
                {{ $t('page.onboarding.coin_account_warning') }}

                <hr />
                <v-button
                  id="onboarding-back"
                  text="word.back"
                  icon="chevron-left"
                  style-type="danger"
                  size="sm"
                  @click="currentStep = 2"
                />
              </div>
            </div>
          </transition>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <v-button
        id="onboarding-next"
        icon="chevron-right"
        text="word.next"
        style-type="secondary"
        v-if="currentStep < 3"
        :disabled="currentStep > 2"
        @click="nextStep()"
      />

      <v-button
        id="onboarding-finish"
        icon="star"
        text="word.finish"
        v-if="currentStep === 3"
        @click="finishOnboarding()"
        :loader="loader"
      />
    </template>
  </v-modal>
</template>

<script>
import Button from '@/common/components/Button.vue';
import Modal from '@/common/components/Modal.vue';
import DateInput from '@/common/components/inputs/DateInput.vue';
import RadioButtons from '@/common/components/inputs/RadioButtons.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import api from '@/common/api';
import { mapActions, mapGetters } from 'vuex';
import { toFormattedDate } from '@/common/utils/formatting';
import { notify } from '@/common/utils/notify';
import { GENDER_CHOICES } from '@/common/utils/constants';

export default {
  name: 'OnboardingModal',
  components: {
    'v-modal': Modal,
    'v-button': Button,
    'v-date-input': DateInput,
    'v-radio-buttons': RadioButtons,
    'v-text-input': TextInput,
  },
  data() {
    return {
      GENDER_CHOICES,
      cellClass: 'wizard-content-cell d-flex flex-column justify-content-center align-items-center',
      currentStep: 1,
      formData: {
        zip: null,
        gender: null,
        birth_date: null,
      },
      errors: {},
      loader: { loading: false },
    };
  },
  computed: {
    ...mapGetters(['user']),
    dataComplete() {
      return this.formData.zip && this.formData.gender && this.formData.birth_date;
    },
  },
  methods: {
    ...mapActions(['refreshUser']),
    nextStep() {
      if (this.currentStep === 2) {
        this.goToStepThree();
      } else if (this.currentStep < 3) {
        this.currentStep += 1;
      }
    },
    goToStepThree() {
      if (!this.formData.birth_date) {
        this.currentStep = 3;
      } else {
        const days = Math.floor((new Date() - this.formData.birth_date) / (1000 * 60 * 60 * 24));
        if (days / 365 < 13 || days / 365 > 90) {
          this.errors = { birth_date: [this.$t('sentence.birth_date_error')] };
        } else {
          this.currentStep = 3;
        }
      }
    },
    async finishOnboarding() {
      this.loader.loading = true;
      const data = JSON.parse(JSON.stringify(this.formData));
      data.birth_date = toFormattedDate(this.formData.birth_date);
      const response = await api.patch(
        `user-profiles/${this.user.profile.id}/finish-onboarding/`,
        data,
      );

      if (response.status === 400) {
        this.errors = response.data;
        this.currentStep = 2;
        this.loader.loading = false;
        return;
      }

      await this.refreshUser();
      this.$emit('hide-modal');
      this.loader.loading = false;
      notify('phrase.onboarding_success', 'sentence.onboarding_success');
    },
  },
  created() {
    if (this.user.profile.zip) {
      this.formData.zip = this.user.profile.zip.replace(/[^0-9]+/g, '');
    } else {
      this.formData.zip = '';
    }

    this.formData.gender = this.user.profile.gender;
    if (this.user.profile.birth_date) {
      this.formData.birth_date = new Date(this.user.profile.birth_date);
    }
  },
};
</script>

<style>
.wizard-content-wrapper {
  height: 330px;
}

.wizard-content-cell {
  height: 300px;
}


@media (max-width: 767px) {
  /* Small screens */
  .wizard-content-cell {
    height: auto;
  }

  .wizard-content-wrapper {
    height: auto;
  }
}
</style>
